import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    Menu,
    MenuButton,
    MenuList,
    Drawer,
    DrawerBody,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    useDisclosure,
} from "@chakra-ui/react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {
    generateAuthorizationCode,
    setActionPayload,
    setActionType,
    setAuthorizationCode,
    setQrData,
    setStatus,
    getExpAuthCodeOnClose,
    setOpLoading
} from '../features/authorizationSlice';
import {faBars} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import "./../utils/Style/component/sidebar.scss";
import useLogout from "../api/logoutApi";
import PortalActionsQr from "../components/PortalActionsQr";
import useCheckAuthorizationStatusHandler from "../app/checkAuthorizationStatusHandler";
import MerchantInformationAPI from "../api/MerchantInformationAPI";
import ValidationPopup from "../components/ValidationPopup";
import BlurLoading from "../components/BlurLoading";
import useLoginAPI from "../api/loginAPI";
import {handleImageError} from "../utils/functions";


function Layout() {
    const [navClick, setNavClick] = useState("");
    const [transactionBtn, setTransactionBtn] = useState(false);
    const [entityType, setEntityType] = useState(sessionStorage.getItem("EntityType"));
    const entityRole = sessionStorage.getItem("EntityRole")

    const {isOpen: isDrawerOpen, onOpen: handleOpen, onClose: onDrawerClose} = useDisclosure();
    const {authorizationCode} = useSelector((state) => state.authorization);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {logout} = useLogout();
    const {checkQrAxios} = useLoginAPI();
    const location = useLocation();

    useEffect(() => {
        const paths = location.pathname.split('/');

        const firstPath = paths[1] || 'default';
        setNavClick(firstPath);
        sessionStorage.setItem("navClick", firstPath);
    }, [location]);


    // useEffect(() => {
    //     if (sessionStorage.getItem("navClick") != null && sessionStorage.getItem("navClick") !== undefined) {
    //         setNavClick(sessionStorage.getItem("navClick"))
    //     } else {
    //         setNavClick("Overview")
    //     }
    // }, [navClick]);

    useEffect(() => {
        checkQrAxios();
    }, []);

    const Merchants = sessionStorage.getItem("Merchants") ? JSON.parse(sessionStorage.getItem("Merchants")) : [];
    const Entities = sessionStorage.getItem("Entities") ? JSON.parse(sessionStorage.getItem("Entities")) : [];

    const currentMerchant = parseInt(sessionStorage.getItem("EntityID"));

    const {SaveUserEmployeeSelectedMerchant} = MerchantInformationAPI();

    const handleLogout = async () => {
        await logout();
    };
    const {isOpen, onClose, onOpen} = useDisclosure();

    const {
        isOpen: isOpenQr,
        onOpen: onOpenQr,
        onClose: onCloseQr,
    } = useDisclosure();

    const onOpenQrAfterGenerate = () => {
        dispatch(generateAuthorizationCode());
        onOpenQr();
    }

    const onCloseQrWhilePending = () => {
        setStatus("CLOSED");
        setOpLoading("idle");
        const authCode = authorizationCode;
        dispatch(getExpAuthCodeOnClose({authCode}));
        onCloseQrReset();
    }

    const onCloseQrReset = () => {
        dispatch(setAuthorizationCode(""));
        dispatch(setQrData(""));
        dispatch(setStatus(""));
        dispatch(setActionType(""));
        dispatch(setActionPayload(null));
        onCloseQr();
    }

    useCheckAuthorizationStatusHandler(onCloseQrReset);

    const handleNavClick = (clickedLink) => {
        sessionStorage.setItem("navClick", clickedLink);
        setNavClick(clickedLink);
    };

    const renderLink = (name, label) => {
        const path = name.toLowerCase().replace(/ /g, "");
        return (
            <div className={(navClick === name || navClick.toLowerCase() === path) ? "subTitleClicked" : "subTitle"}>
                <button
                    className={(navClick === name || navClick.toLowerCase() === path) ? "navLinkClicked" : "navLink"}
                    onClick={() => {
                        handleNavClick(name);
                        navigate("/" + name.toLowerCase().replace(/ /g, ""));
                    }}
                >
                    {label ?? name}
                </button>
            </div>
        );
    };

    return (
        <div className="container sidebar">
            <div className="row">
                <div className="col-lg-2 d-none d-lg-block g-0 left">
                    <div className="Logo">
                        <img src="/Images/suyool_logo.png" alt="Logo"/>
                    </div>

                    {
                        entityType !== "MERCHANTEMPLOYEE" ? (
                            <>
                                <div className="Title">LEGAL ACCOUNT</div>
                                {renderLink("Overview")}
                                {renderLink("Statement of Account")}
                                <div className="Title">TRANSACTIONS</div>
                                {renderLink("Bank Transfers", "External Transfer")}
                                {renderLink("Suyool to Suyool")}
                                {renderLink("Exchange")}
                                {/*{renderLink("Cash Delivery", "Cash Out")}*/}

                                {transactionBtn ?
                                    <div className="btn_container_True">
                                        <div className="btn-list">
                                            <button className="newTransaction" onClick={() => {
                                                setTransactionBtn(false)
                                            }}> + New Transaction
                                            </button>
                                            {/*<button className="Transaction" onClick={() => {*/}
                                            {/*    setNavClick("Bank Transfers");*/}
                                            {/*    sessionStorage.setItem("navClick", "Bank Transfers");*/}
                                            {/*    navigate('/banktransfers', {state: {name: '+ New Transfer'}});*/}
                                            {/*}}>Transfer*/}
                                            {/*</button>*/}
                                            <button className="Transaction" onClick={() => {
                                                setNavClick("Suyool to Suyool");
                                                sessionStorage.setItem("navClick", "Suyool to Suyool");
                                                navigate('/suyooltosuyool', {state: {name: '+ New Free Transfer'}});
                                            }}>Send Money
                                            </button>
                                            <button className="Transaction" onClick={() => {
                                                setNavClick("Exchange");
                                                sessionStorage.setItem("navClick", "Exchange");
                                                navigate('/exchange');
                                            }}>Exchange
                                            </button>
                                            {/*<button className="Transaction" onClick={() => {*/}
                                            {/*    setNavClick("Cash Delivery");*/}
                                            {/*    sessionStorage.setItem("navClick", "Cash Delivery");*/}
                                            {/*    navigate('/cashdelivery', {state: {name: '+ New Order'}});*/}
                                            {/*}}>Cash Delivery*/}
                                            {/*</button>*/}

                                        </div>
                                    </div>
                                    :
                                    <>
                                        {
                                            entityRole !== "VIEWER" ? (
                                                <div className="btn_container">
                                                    <div className="btn-sub">
                                                        <button className="newTransaction" onClick={() => {
                                                            setTransactionBtn(true)
                                                        }}> + New Transaction
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (<></>)
                                        }
                                    </>
                                }
                                <div className="Title">CORPORATE CARDS</div>
                                {renderLink("Cards Settings")}
                                {renderLink("Card Transactions")}
                            </>
                        ) : (
                            <>
                                <div className="Title">BUSINESS ACCOUNT</div>
                                {renderLink("Overview", "Sales Overview")}
                                {renderLink("statementofaccount", "Sales Transactions")}
                                {entityRole !== "Supervisor" && renderLink("EOD Closing")}

                                <div className="Title">TRANSACTIONS</div>
                                {renderLink("Payment Request")}

                                {/*<div className="Title">REPORTS</div>*/}
                                {/*{renderLink("Standing Order", "Create Custom Report")}*/}
                                {/*{renderLink("Exported Reports")}*/}

                            </>)
                    }


                    <div className="Title">SETTINGS</div>

                    {entityType !== "MERCHANTEMPLOYEE" ? renderLink("Merchant Information", "Legal Information") : renderLink("Merchant Information")}
                    {entityType === "MERCHANTEMPLOYEE" && renderLink("Branches")}
                    {/* {renderLink("Cash Management")} */}
                    {(entityType === "MERCHANTEMPLOYEE" && entityRole !== "Supervisor" || (entityType === "LEGALENTITY" && entityRole !== "ADMIN" && entityRole !== "VIEWER")) && renderLink("Employees")}

                    <div className="bottomSide">
                        <div className="Support">
                            <img src="/Images/logo/support.png" alt="Logo"/>
                            <p>24h Support</p>
                        </div>
                        <p>contact@suyool.com</p>
                        <p>+961 81 484 000</p>
                    </div>

                </div>


                <div className="col-lg-10 col-md-12 g-0 right">
                    <div className="header">
                        <div className="date d-none d-lg-block">{sessionStorage.getItem("EntityName")}</div>
                        <div>
                            <button className="d-block d-lg-none barsBtn" onClick={handleOpen}><FontAwesomeIcon
                                icon={faBars}/></button>
                            <Drawer isOpen={isDrawerOpen} placement='left' onClose={onDrawerClose}>
                                <DrawerOverlay/>
                                <DrawerContent>
                                    <DrawerCloseButton/>
                                    <DrawerHeader>Suyool</DrawerHeader>

                                    <DrawerBody>
                                        {/*<div>*/}
                                        {/*    /!* <div className="Title">BUSINESS ACCOUNT</div> *!/*/}
                                        {/*    {renderLink("Overview")}*/}
                                        {/*    {renderLink("Statement of Account")}*/}
                                        {/*    /!* <div className="Title">TRANSACTIONS</div> *!/*/}
                                        {/*    {renderLink("Bank Transfers")}*/}
                                        {/*    {renderLink("Suyool to Suyool")}*/}
                                        {/*    {renderLink("Exchange")}*/}
                                        {/*    /!*{renderLink("Cash Delivery")}*!/*/}
                                        {/*    /!* <div className="Title">REPORTS</div> *!/*/}
                                        {/*    {renderLink("Standing Order")}*/}
                                        {/*    /!*{renderLink("Exported Reports")}*!/*/}
                                        {/*    /!* <div className="Title">SETTINGS</div> *!/*/}
                                        {/*    {renderLink("Merchant Information")}*/}
                                        {/*    {renderLink("Branches")}*/}
                                        {/*    {renderLink("Cash Management")}*/}
                                        {/*    {renderLink("Employees")}*/}

                                        {/*</div>*/}
                                    </DrawerBody>
                                    <div className="bottomSide">
                                        <div className="Support">
                                            <p>24h Support</p>
                                        </div>
                                        <p>contact@suyool.com</p>
                                        <p>+961 81 484 000</p>
                                    </div>

                                </DrawerContent>
                            </Drawer>
                        </div>
                        <div className="userInfo">
                            <div className="notification"></div>
                            {/*{ Dropdown }*/}
                            <Menu isOpen={isOpen} onClose={onClose}>
                                <MenuButton w='100%' textAlign='start' onClick={onOpen}>
                                    <div className="user">
                                        <div className="user-profile">
                                            {
                                                sessionStorage.getItem("EntityURL") ? (
                                                    <img src={sessionStorage.getItem("EntityURL")}
                                                         onError={handleImageError}/>
                                                ) : (
                                                    <img src="/Images/skash_emptypp.jpg"/>
                                                )
                                            }
                                        </div>
                                        <p className="userName">{sessionStorage.getItem("UserName")}</p>
                                    </div>
                                </MenuButton>
                                <MenuList zIndex={9999}>
                                    {/*    <MenuItem closeOnSelect={false}>*/}
                                    <div className="legal-list">
                                        {
                                            Entities.length > 0 &&
                                            <>
                                                {Entities?.reduce((unique, o) => {
                                                    if (!unique.some(obj => obj.LegalEntityID === o.LegalEntityID && obj.LegalEntityName === o.LegalEntityName)) {
                                                        unique.push(o);
                                                    }
                                                    return unique;
                                                }, [])?.map((entity) => {
                                                    const isCurrentLegal = entity.LegalEntityID === currentMerchant;
                                                    return (
                                                        <>
                                                            <div
                                                                className={isCurrentLegal ? "legal active" : "legal"}
                                                                onClick={isCurrentLegal
                                                                    ? () => {
                                                                    }
                                                                    : async () => {
                                                                        await SaveUserEmployeeSelectedMerchant(
                                                                            entity
                                                                        );
                                                                        onClose();
                                                                    }}
                                                            >
                                                                <img
                                                                    src={entity.LegalIconUrl ?? "/Images/skash_emptypp.jpg"}
                                                                    alt=""/>
                                                                <span>{entity.LegalEntityName}</span>
                                                            </div>
                                                            {
                                                                (Merchants.length > 0 && (entity.LegalEntityID === Number(sessionStorage.getItem("LegalEntityID")) || isCurrentLegal)) &&
                                                                <div className="merchant-list">
                                                                    {Merchants?.reduce((unique, o) => {
                                                                        if (!unique.some(obj => obj.MerchantID === o.MerchantID && obj.MerchantName === o.MerchantName)) {
                                                                            unique.push(o);
                                                                        }
                                                                        return unique;
                                                                    }, [])?.map((merchant, index) => {
                                                                        const isCurrentMerchant = merchant.MerchantID === currentMerchant;
                                                                        return (
                                                                            <div
                                                                                className={isCurrentMerchant ? "merchant merch-active" : "merchant"}
                                                                                onClick={
                                                                                    isCurrentMerchant
                                                                                        ? () => {
                                                                                        }
                                                                                        : async () => {
                                                                                            await SaveUserEmployeeSelectedMerchant(
                                                                                                merchant
                                                                                            );
                                                                                            onClose();
                                                                                        }
                                                                                }
                                                                            >
                                                                                <div className="round"></div>
                                                                                {
                                                                                    (index !== Merchants.length - 1) &&
                                                                                    <div className="line"></div>
                                                                                }
                                                                                <span>{merchant.MerchantName}</span>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>

                                                            }
                                                        </>);
                                                })}

                                            </>
                                        }
                                        {/*<div className="legal">*/}
                                        {/*    <img src="/Images/skash_emptypp.jpg" alt=""/>*/}
                                        {/*    <span>Azadea Group</span>*/}
                                        {/*</div>*/}
                                        {/*<div className="merchant-list">*/}
                                        {/*    <div className="merchant">*/}
                                        {/*        <div className="round"></div>*/}
                                        {/*        <div className="line"></div>*/}
                                        {/*        <span>Adidas</span>*/}
                                        {/*    </div>*/}
                                        {/*    <div className="merchant merch-active">*/}
                                        {/*        <div className="round"></div>*/}
                                        {/*        <div className="line"></div>*/}
                                        {/*        <span>Bershka</span>*/}
                                        {/*    </div>*/}
                                        {/*    <div className="merchant">*/}
                                        {/*        <div className="round"></div>*/}
                                        {/*        <span>Bose</span>*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        {/*<div className="legal">*/}
                                        {/*    <img src="/Images/skash_emptypp.jpg" alt=""/>*/}
                                        {/*    <span>Retail Group</span>*/}
                                        {/*</div>*/}
                                        {/*<div className="legal">*/}
                                        {/*    <img src="/Images/skash_emptypp.jpg" alt=""/>*/}
                                        {/*    <span>Malia Group</span>*/}
                                        {/*</div>*/}
                                        <button className="logout" onClick={handleLogout}>Logout</button>
                                    </div>

                                    {/*</MenuItem>*/}
                                </MenuList>
                            </Menu>

                        </div>
                    </div>
                    <div>
                        <Outlet context={[onOpenQrAfterGenerate, onCloseQrReset]}/>
                    </div>
                </div>
            </div>
            <PortalActionsQr isOpen={isOpenQr} onClose={onCloseQrWhilePending}/>
            <ValidationPopup onOpenQrAfterGenerate={onOpenQrAfterGenerate}/>
            <BlurLoading isGlobal={true}/>
        </div>
    );
}

export default Layout;

